import { TextField, Typography, Box } from "@mui/material";

// Converts dd-MM-yyyy (stored) → yyyy-MM-dd (for HTML date input display)
const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
};

// Converts yyyy-MM-dd (from HTML date input) → dd-MM-yyyy (for storage / backend)
const formatDateForStorage = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
};


const NurturSecurityChequeDepositLetterForm = ({ data, setData }) => {

    const handleChange = (key, value) => {
        if (key === "security_cheque_date" || key === "cheque_date" || key === "joining_date") {
            value = formatDateForStorage(value);
        }

        setData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    return (
        <Box sx={{ mt: 1 }}>


            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                    gap: 2
                }}
            >
                <Box>
                    <TextField
                        type="date"
                        label="Date"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.security_cheque_date ? formatDateForInput(data.security_cheque_date) : ""}
                        onChange={(e) => handleChange("security_cheque_date", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        type="date"
                        label="Joining Date"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.joining_date ? formatDateForInput(data.joining_date) : ""}
                        onChange={(e) => handleChange("joining_date", e.target.value)}
                    />
                </Box>

                {/* <Box>
                    <TextField
                        label="Employee Address"
                        fullWidth
                        value={data.employee_address || ""}
                        onChange={(e) => handleChange("employee_address", e.target.value)}
                    />
                </Box> */}

                <Box>
                    <TextField
                        type="date"
                        label="Cheque Date"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.cheque_date ? formatDateForInput(data.cheque_date) : ""}
                        onChange={(e) => handleChange("cheque_date", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        label="Cheque No."
                        fullWidth
                        value={data.cheque_no || ""}
                        onChange={(e) => handleChange("cheque_no", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        label="Bank Name"
                        fullWidth
                        value={data.bank_name || ""}
                        onChange={(e) => handleChange("bank_name", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        label="A/c. No."
                        fullWidth
                        value={data.account_number || ""}
                        onChange={(e) => handleChange("account_number", e.target.value)}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default NurturSecurityChequeDepositLetterForm;
